import styled from "styled-components";
import {IndicatorBadgeDefaultBox} from "./indicator-badge.default.box";

export const IndicatorBadgeSIBox = styled(IndicatorBadgeDefaultBox)`
    top: -0.4rem;
    right: -1rem;
`;
